import React from 'react';
import { Avatar } from '@mui/material';
import TerrainIcon from '@mui/icons-material/Terrain';
import BuildIcon from '@mui/icons-material/Build';
import EmojiFlagsIcon from '@mui/icons-material/EmojiFlags';
import SchoolIcon from '@mui/icons-material/School';
import PersonIcon from '@mui/icons-material/Person';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { getRoleDisplayPriority } from '../config/roleAccess';

function getRoleIcon(user) {
  if (!user?.roles || !Array.isArray(user.roles)) return 'HR';

  if (user.roles.includes('leiter')) {
    return <WorkspacePremiumIcon fontSize="medium" />;
  }
  if (user.roles.some((role) => role.startsWith('lehrhöhenretter') || role.startsWith('lehrhohenretter'))) {
    return <SchoolIcon fontSize="medium" />;
  }
  if (getRoleDisplayPriority(user) === 'advanced') {
    return <PersonIcon fontSize="medium" />;
  }
  if (user.roles.includes('einheitsführer')) return <EmojiFlagsIcon fontSize="medium" />;
  if (user.roles.includes('geräteprüfer')) return <BuildIcon fontSize="medium" />;
  if (user.roles.includes('bewerber_srht') || user.roles.includes('bewerber_srht_extern')) return <AssignmentTurnedInIcon fontSize="medium" />;
  if (user.roles.includes('höhenretter')) return <TerrainIcon fontSize="medium" />;
  return 'HR';
}

function UserAvatar({ user, size = 40, ...props }) {
  return (
    <Avatar sx={{ bgcolor: 'primary.main', width: size, height: size }} {...props}>
      {getRoleIcon(user)}
    </Avatar>
  );
}

export default UserAvatar;
